import { render, staticRenderFns } from "./ClientsForm.vue?vue&type=template&id=c382a766&scoped=true&"
import script from "./ClientsForm.vue?vue&type=script&lang=js&"
export * from "./ClientsForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientsForm.vue?vue&type=style&index=0&id=c382a766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c382a766",
  null
  
)

export default component.exports